import React from "react";
import { Props } from "./type";

function TrashIcon(props: Props) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.636 20.475"
    >
      <path
        d="M5.778,8.327v12.8a1.283,1.283,0,0,0,1.28,1.28H18.575a1.283,1.283,0,0,0,1.28-1.28V8.327ZM9.618,19.844H8.338V10.886h1.28Zm2.559,0H10.9V10.886h1.28Zm2.559,0h-1.28V10.886h1.28Zm2.559,0h-1.28V10.886H17.3ZM20.175,4.487H16.016v-1.6a.963.963,0,0,0-.96-.96H10.577a.963.963,0,0,0-.96.96v1.6H5.459a.963.963,0,0,0-.96.96v1.6H21.135v-1.6a.963.963,0,0,0-.96-.96Zm-5.439,0H10.9V3.224h3.839V4.487Z"
        transform="translate(-4.499 -1.928)"
      />
    </svg>
  );
}

export { TrashIcon };
